import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { warehousesQueryOptions } from '../../../features/inventory/queries'
import { newAdjustmentSearchSchema } from '../../../features/inventory/search'
import { NewStockAdjustmentPage } from '../../../features/inventory/stock-adjustment-pages'

export const Route = createFileRoute('/_app/stock-adjustments/new')({
  staticData: { crumb: 'stockAdjustmentNew' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'inventory.adjust'),
  validateSearch: newAdjustmentSearchSchema,
  loader: ({ context }) => {
    // Warm the warehouse picker (the main warehouse is preselected); the form does not wait.
    void context.queryClient.prefetchQuery(warehousesQueryOptions)
  },
  component: NewStockAdjustmentPage,
})
